var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfessionalWebsite = function SvgProfessionalWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#professionalWebsite_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FAFBFE",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#professionalWebsite_svg__b)",
    d: "M40.63 9.049H7.37A1.37 1.37 0 0 0 6 10.419v4.057l18 .797 18-.797v-4.057a1.37 1.37 0 0 0-1.37-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#professionalWebsite_svg__c)",
    d: "m42 38.455-18 1.193-18-1.193V14.448h36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BBCEF",
    d: "M6 46.849h36v-10.8H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#professionalWebsite_svg__d)",
    d: "M37.3 27.21v-9.06a.457.457 0 0 0-.457-.457H11.16a.457.457 0 0 0-.457.457v9.06l13.299.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDAD71",
    d: "M11.16 32.81h25.683a.457.457 0 0 0 .456-.457v-5.145H10.703v5.145c0 .253.205.457.457.457"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#professionalWebsite_svg__e)",
    d: "m25.8 46.537-7.65 2.727-7.65-2.727v-5.373c0-1.35.45-1.8 1.8-1.8H24c1.35 0 1.8.45 1.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#professionalWebsite_svg__f)",
    d: "M9.27 10.629a1.056 1.056 0 0 0 0 2.108c.58 0 1.054-.473 1.054-1.054S9.85 10.63 9.269 10.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E9EED",
    d: "M12.652 10.629a1.056 1.056 0 0 0 0 2.108c.581 0 1.054-.473 1.054-1.054s-.473-1.054-1.054-1.054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDEAFF",
    d: "M16.039 10.629c-.582 0-1.055.473-1.055 1.054a1.056 1.056 0 0 0 2.11 0c0-.581-.474-1.054-1.055-1.054"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.9,
    height: 0.9,
    x: 27.602,
    y: 40.311,
    fill: "#fff",
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.9,
    height: 0.9,
    x: 27.602,
    y: 42.211,
    fill: "#fff",
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.9,
    height: 0.9,
    x: 27.602,
    y: 44.111,
    fill: "#fff",
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.9,
    height: 0.9,
    x: 27.602,
    y: 46.011,
    fill: "#fff",
    rx: 0.45
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.4,
    height: 46.4,
    x: 0.8,
    y: 0.8,
    stroke: "#D1D9E9",
    strokeWidth: 1.6,
    rx: 11.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "professionalWebsite_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(165.839 15.095 6.71)scale(16.7014 9.47677)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C8FC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A60B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "professionalWebsite_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(143.102 16.947 14.593)scale(38.0116 33.9447)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5DBFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "professionalWebsite_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-26.6101 0 0 -8.62932 37.313 24.739)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C88EA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "professionalWebsite_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(136.899 2.694 25.494)scale(11.6428 33.0124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "professionalWebsite_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.53832 2.59422 -3.56046 2.11128 7.69 15.731)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2DDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "professionalWebsite_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgProfessionalWebsite;